import { render, staticRenderFns } from "./SideFilter.vue?vue&type=template&id=aafeb734&scoped=true&"
import script from "./SideFilter.vue?vue&type=script&lang=js&"
export * from "./SideFilter.vue?vue&type=script&lang=js&"
import style0 from "./SideFilter.vue?vue&type=style&index=0&id=aafeb734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafeb734",
  null
  
)

export default component.exports